import { State } from './state';
import { requestUrl } from '../core/constants';

export const initialState: State = {
  notifications: [],
  env: {
    requestUrl
  }
};
